import React from "react";
import { DirectorySync } from "./DirectorySync";

export const Directory = () => {
  return <DirectorySync />;
};
